import { ApiUsersCurrentTransactionSource } from "utils/api/users";

export const TRANSACTION_SOURCE_TO_LABEL_MAP: {
  [key in ApiUsersCurrentTransactionSource]: string;
} = {
  checking: "Checking Only",
  ewa: "Earnings Only",
  flex: "Earnings First",
};
